'use client';

import { useSearchParams } from 'next/navigation';

import { getIsServerEnv } from '@/shared/modules/environment';
import { getStorageItem } from '@/shared/modules/local-storage';
import { MARKETING_DOWNLOAD_KEY } from '@/shared/modules/local-storage/constants';

export const useGetQueryParams = (overrideParams = {}) => {
  const currentParams = useSearchParams();
  if (getIsServerEnv()) {
    return {};
  }

  const params = getStorageItem(MARKETING_DOWNLOAD_KEY, {});
  const newParams = {
    ...(Object.fromEntries(currentParams) || {}),
    ...(params || {}),
    ...overrideParams,
  };

  return newParams;
};
